import React from 'react';
import { useStoreActions } from 'easy-peasy';

const host = 'https://apitzedaka.codersuccess.com';
// const host = 'https://localhost:44377';  

export const Post = async (endpoint, payload) => {
    endpoint = endpoint.includes('https://') ? endpoint : host + endpoint;
    return new Promise((resolve) => {
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const response = JSON.parse(this.response);
                console.log('response group updated', response);
                return resolve(response);
            }
            return false;
        };
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        console.log('payload', payload);
        xhr.send(JSON.stringify(payload));
    });
};

export const PostAuthorized = async (endpoint, payload) => {
    endpoint = endpoint.includes('https://') ? endpoint : host + endpoint;
    return new Promise((resolve) => {
        let xhr = new XMLHttpRequest();
        xhr.onreadystatechange = function () {
            if (this.readyState === 4 && this.status === 200) {
                const response = JSON.parse(this.response);
                console.log('response group updated', response);
                return resolve(response);
            }
            return false;
        };
        xhr.open('POST', endpoint, true);
        xhr.setRequestHeader('Content-type', 'application/json');
        xhr.setRequestHeader('Authorization', 'Bearer ' + localStorage.getItem('token'));
        const stringToSend = JSON.stringify(payload);
        console.log('stringToSend', stringToSend);
        xhr.send(stringToSend);
        // xhr.send(JSON.stringify({ cryptoName : 'wnew name' }));
    });
};

const serialize = (obj) => {
    const str = [];
    for (let p in obj) {
        if (obj.hasOwnProperty(p)) {
            str.push(encodeURIComponent(p) + '=' + encodeURIComponent(obj[p]));
        }
    }
    return str.join('&');
};

export const GetAthourized = async (endpoint, payload) => {    
    endpoint = endpoint.includes('https://') ? endpoint : host + endpoint;
    let queryString = '';
    if (payload !== '') {
        queryString = '?' + serialize(payload);
    }

    let response = await fetch(endpoint + queryString, {
        method: 'get',
        headers: new Headers({
            Authorization: 'Bearer ' + localStorage.getItem('token'),
            'Content-Type': 'application/json'
        })
    });
    const json = await response.json();
    console.log('get json result', json);
    return json;
};

export const Get = async (endpoint, payload) => {
    endpoint = endpoint.includes('https://') ? endpoint : host + endpoint;
    let queryString = '';
    if (payload !== '') {
        queryString = '?' + serialize(payload);
    }

    let response = await fetch(endpoint + queryString, {
        method: 'get'
    });
    const json = await response.json();
    console.log('get json result', json);
    return json;
};

export default Get;
